import React from "react";
import { CrudModal } from "../modals/CrudModal";
import { CrudDrawerProps } from "./CrudDrawer.types";

/** `CrudModal` in a side drawer, for records with more fields than a modal holds. */
export const CrudDrawer: React.FC<CrudDrawerProps> = (props) => {
  return <CrudModal {...props} asDrawer />;
};
